export default __webpack_public_path__ + "static/media/46.60650eb1.png";